// Add a listener to the country dropdown so that when the user selects a country,
// the region dropdown is populated with the regions for that country.
const countryDropdown = document.getElementById('country') as HTMLSelectElement;
const regionDropdown = document.getElementById('region') as HTMLSelectElement;
const submit =
  (document.getElementById('continue-checkout') as HTMLButtonElement) ||
  (document.getElementById('edit-form-submit') as HTMLButtonElement) ||
  (document.getElementById('submit-request') as HTMLButtonElement);

countryDropdown.addEventListener('change', async (event) => {
  const targetElement = event.target as HTMLElement;
  const formElement = targetElement.closest('form');
  const selectedCountry = countryDropdown.value;

  // Remove any potential http errors that were displayed when
  // trying to fetch the regions to populate the respective dropdown.
  removeErrorOnForm(formElement);

  await fetchRegionsForCountry(selectedCountry, formElement);
});
countryDropdown.removeAttribute('disabled');

// Don't allow user to submit the form before the country dropdown has been
// enabled. Without this safeguard in place we can end up with test failures
// where the form is submitted without a country input.
submit?.removeAttribute('disabled');

// fetchRegionsForCountry fetches the regions for the provided country code
// and populates the region dropdown with the results.
async function fetchRegionsForCountry(
  countryCode: string,
  formElement: HTMLElement | null,
): Promise<void> {
  // Disable and require region field while reload to prevent
  // a race condition in the Playwright tests.
  regionDropdown.disabled = true;

  // Wrapping in a conditional instead of using && operator to make it clear that
  // geoip-correction.ts handles setting the required attribute.
  if (!regionDropdown.classList.contains('js-geoip-correction-region')) {
    regionDropdown.required =
      !regionDropdown?.classList.contains('admin-optional');
  }
  regionDropdown.innerHTML = '';

  if (!countryCode) {
    populateRegions({});
    return;
  }

  let json;
  try {
    const response = await fetch(`/en/country/${countryCode}/regions`);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    json = await response.json();
  } catch (error) {
    // Reset country dropdown to its default so the user has to re-select their
    // original selection (which will trigger another fetch attempt to populate
    // the region dropdown).
    const countryDropdown = document.getElementById(
      'country',
    ) as HTMLSelectElement;
    countryDropdown.selectedIndex = 0;

    const errorMessage = `Failed to fetch regions for country: ${countryCode}. Error: ${error instanceof Error ? error.message : ''}`;
    displayErrorOnForm(errorMessage, formElement);
    return;
  }

  populateRegions(json.data);
}

// populateRegions populates the region dropdown with the provided data.
function populateRegions(data: { [key: string]: string }) {
  const sortedRegions = Object.entries(data).sort((a, b) => {
    return a[1].localeCompare(b[1]);
  });

  if (!sortedRegions.length) {
    regionDropdown.required = false;
    return;
  }

  const option = document.createElement('option');
  regionDropdown.appendChild(option);

  sortedRegions.forEach(([code, name]) => {
    const option = document.createElement('option');
    option.value = code;
    option.textContent = name;
    regionDropdown.appendChild(option);
  });

  regionDropdown.disabled = false;
}

// displayErrorOnForm adds an alert div containing an error message to the top
// of the form containing the provided formElement.
function displayErrorOnForm(message: string, formElement: HTMLElement | null) {
  if (!formElement) return;

  // Create the new error div
  const errorDiv = document.createElement('div');
  errorDiv.id = 'js-regions-for-country-alert';
  errorDiv.className = 'alert alert-danger';
  errorDiv.role = 'alert';
  errorDiv.textContent = message;

  formElement.insertBefore(errorDiv, formElement.firstChild);
}

// removeErrorOnForm removes any error that was previously added to the form
// containing the provided formElement.
function removeErrorOnForm(formElement: HTMLElement | null) {
  const errorDiv = formElement?.querySelector('#js-regions-for-country-alert');
  if (errorDiv) {
    errorDiv.remove();
  }
}
